<template>
  <div class="progress">
    <h2 class="mb-8">{{ $ucfirst($t("journeyProgress.journeyToHealthyLifestyle")) }}</h2>
    <journey-button-line />
    <router-view></router-view>
    <discussion-step-nav-buttons
      :nextRoutes="nextDiscussionStep"
      :prevRoutes="prevDiscussionStep"
    >
    </discussion-step-nav-buttons>
  </div>
</template>

<script>
import DiscussionStepNavButtons from '../../../components/Parts/DiscussionStepNavButtons.vue';
import JourneyButtonLine from "../../../components/Parts/JourneyButtonLine";

/**
 * Component Progress.vue
 *
 * @module Progress
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/views/Patient/Progress/Progress.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientOverviewProgress',
  props: ['nextDiscussionStep', 'prevDiscussionStep'],
  components: {
    JourneyButtonLine,
    DiscussionStepNavButtons
  },
};
</script>
